import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import React from 'react';
import { useBlocker } from 'react-router-dom';

export const DiscardDialog: React.FC<{
  open: boolean;
  stepTitle: string;
  onDiscard: () => void;
  onKeep: () => void;
}> = ({ open, stepTitle, onDiscard, onKeep }) => (
  <Dialog open={open} onClose={onKeep}>
    <DialogTitle>Discard your changes?</DialogTitle>
    <DialogContent>
      <DialogContentText>
        Your changes to {stepTitle} haven't been saved.
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onKeep}>Keep editing</Button>
      <Button color="warning" onClick={onDiscard}>
        Discard
      </Button>
    </DialogActions>
  </Dialog>
);

/**
 * While `active`, holds navigation away from the page until the user decides,
 * and has the browser ask before reloading or closing the tab. `allowLeave`
 * lets through a navigation the flow starts itself.
 */
export const useLeaveGuard = (active: boolean) => {
  const allowed = React.useRef(false);
  const blocker = useBlocker(() => active && !allowed.current);

  React.useEffect(() => {
    if (!active) {
      return;
    }
    const warn = (event: BeforeUnloadEvent) => event.preventDefault();
    window.addEventListener('beforeunload', warn);
    return () => window.removeEventListener('beforeunload', warn);
  }, [active]);

  return {
    blocked: blocker.state === 'blocked',
    leave: () => blocker.proceed?.(),
    stay: () => blocker.reset?.(),
    allowLeave: () => {
      allowed.current = true;
    },
  };
};
